/* eslint-disable */

import EmojiPicker from 'vue-emoji-picker';
import Push from 'push.js';
import audioPlay from '@/assets/audio/piano.mp3';
import axios from 'axios';
import { bus } from '@/main';
import commonSocketConnectMethod from "@/commonSocket";
import fileExtension from '@/mixins/checkextension';
import { mapGetters } from 'vuex';
import moment from 'moment';
import root from '@/_helpers/roots';
import toast from '@/services/toast';

let UploadMsgFileURL = root.uploadMsgFileUrl.link;
var pingInterval;
const $ = window.jQuery = require('jquery');
const msgDeletePopup = () => import('@/components/private/workspace/msg-delete-popup/');
const percentageLoader = () => import('@/components/common/percentage-loader-f-file/');


export default {
  name: 'user-chatbot',
  mixins: [fileExtension],
  components: {
    'msg-delete-popup': msgDeletePopup,
    percentageLoader,
    EmojiPicker
  },
  props: [],
  data() {
    return {
      apiLoader:false,
      roomChatId: '',
      socketForRoomId:'',
      userInfo: null,
      messagesList: [],
      typingUserInfoState: null,
      messageCount: 0,
      token: localStorage.getItem('token') || null,
      msgNextPageLoader: '', 
      selfUserId: '',
      chatSocket: null, 
      openSupportChatState:false,
      replyMessageData:null,
      deleteMsgPopupState:false,
      deleteMessageDataObj: {
        id: '',
        text: '',
        time: '',
        createdBy: '',
        roomId:'',
      },
      fileUploadLoader:false,
      uploadFile:null,
      filename:'',
      uploadProgress: 0,
      submitted:false,
      fileMessage:'',
      textMessage:'',
      imgSrc:'',
      messageIdForReply:'',
      selfUserInfo: null,
      emojis: ["👍", "👎", "😭", "😕", "😐", "😊", "😍",],
      typingTimeout:null,
      lastLiveMsgData:null
    };
  },
  computed: {
    ...mapGetters([
      'acUserDetailsStateGetters'
    ]),
    getSelfUserInfo() {
      this.selfUserInfo = this.$store.getters.acUserDetailsStateGetters.data;
      return;
    },
  },
  mounted() {
    this.selfUserId = localStorage.getItem('LoginedUserID');
    this.getSelfUserInfo;
    this.handleMessageLoader();
    this.setupBusListeners();
    bus.$on('deleteMsgPopupStateBus', (data) => {
      this.deleteMsgPopupState = data;
    })
    // Assuming 'bus' is an existing event bus or custom event dispatcher
    bus.$on('MessageDeleteForChatOfAllNotification', (data) => {
      const chatMessageElement = document.getElementById('chatMessageId' + data.id);
      if (chatMessageElement) {
        const dropdown = chatMessageElement.querySelector('.dropdown');
        if(dropdown){
         dropdown.remove();
        }
        const replyWrapper = chatMessageElement.querySelector('.show_msg_of_reply_wrp');
        if(replyWrapper){
          replyWrapper.remove();
        }
        const label = chatMessageElement.querySelector('label');
        if(label){
          label.remove();
        }
        const chatMsgBoxWrp = chatMessageElement.querySelector('.chat_in_msg_box_wrp');
        if(chatMsgBoxWrp){
          chatMsgBoxWrp.classList.add('delete_msg_show_box');
          const msgInFile = chatMessageElement.querySelector('.msg_in_file');
          if(msgInFile){
            msgInFile.style.color = "#4c4c4c";
            msgInFile.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
          }else{
            const anchorTag = chatMsgBoxWrp.querySelector('span');
            anchorTag.style.color = "#4c4c4c";
            anchorTag.innerHTML = "<i aria-hidden='true' class='fa fa-ban'></i> This message was deleted";
        }
        }
      }
    });
  },
  watch: {
    getSelfUserInfo() {
      return this.$store.getters.acUserDetailsStateGetters;
    },
  },
  methods: {
    insertEmojiMethod(emoji) {
      this.fileMessage += emoji;
      this.textMessage += emoji;
    },
    messagesIndicationStatusMethod(item) {
      if (!item) return;
      const allRead = item.every(status => status.is_read);
      const allDelivered = item.every(status => status.is_delivered);
      if (allRead) {
        return 'read';
      } else if (allDelivered) {
        return 'delivered';
      } else {
        return 'undelivered';
      }
    },
    setupBusListeners() {
      bus.$on('typingEventForChatBus', this.handleTypingEvent);
      bus.$on('selfUserUpdateStatus', this.handleSupportMessageCountNotification);
      bus.$on('updateMessageNotifications', this.handleLiveSchatCountNotification);
    },

    handleTypingEvent(data) {
      this.typingUserInfoState = data;
      if (data.message === 'stop') {
        this.typingUserInfoState = null;
      }
    },

    handleSupportMessageCountNotification(data) {
      this.messageCount = data.supportUnreadCount;
    },

    handleLiveSchatCountNotification(data) {
      if(data.supportUnreadCount > 0){
        if(Push.Permission.has()){
          Push.create("Lymphomap Admin", {
            body:data.message,
            timeout:4000,
            onClick: function () {
                window.focus();
                this.close();
            }
          })
          this.messageCount = data.supportUnreadCount;
        }else{
          this.messageCount = data.supportUnreadCount;
          this.playSound(audioPlay);
        }
      }
    },
    
    playSound (sound) {
      if(sound) {
        var audio = new Audio(sound);
        audio.play();
      }
    },

    handleMessageLoader() {
      const elmntList = document.getElementById("chatbot_scroll");
      if (!elmntList) return;

      elmntList.addEventListener("scroll", () => {
        if (elmntList.scrollTop === 0) {
          if (this.msgNextPageLoader) {
            axios.get(this.msgNextPageLoader)
              .then((response) => {
                if (response.status === 200 && response.data && response.data.data) {
                  const { next, results } = response.data.data;
                  const previousScrollHeight = elmntList.scrollHeight;

                  this.msgNextPageLoader = next;
                  this.messagesList = [...this.messagesList, ...results];

                  this.$nextTick(() => {
                    elmntList.scrollTop = elmntList.scrollHeight - previousScrollHeight;
                  });
                }
              })
              .catch((err) => {
                console.error("Error loading older messages:", err);
              });
          }
        }
      });
    },

    async chatRoomCreationMethod() {

      try {
        this.openSupportChatState = true;
        this.apiLoader = true;
        // const userInfoResponse = await this.$store.dispatch('getAcUserDetailsFun');
        // this.userInfo = userInfoResponse.data;
        // const to_user = userInfoResponse.data.data.id;

        const chatRoomData = {
          users: [this.selfUserId],
          is_support_chat: true,
        };
        const chatRoomResponse = await this.$store.dispatch('chatRoomCreatedFun', chatRoomData);
        const chatId = chatRoomResponse.data.data.id;
        this.roomChatId = chatId; 
        this.socketForRoomId = chatId.replace(/-/g, ""); 

        const messagesResponse = await this.$store.dispatch('getUserSupportHelpChatDetailsByIdFun', { id: this.roomChatId });
        this.messagesList = messagesResponse.data.data.results;
        this.msgNextPageLoader = messagesResponse.data.data.next;
        this.messageCount = 0;
        this.apiLoader = false;
        // Also clear any pending typing timeout from the previous room
        if (this.typingTimeout) {
            clearTimeout(this.typingTimeout);
            this.typingTimeout = null;
        }
        this.$nextTick(() => {
          this.scrollToBottom();
        });

        this.setupWebSocket();

      } catch (err) {
        console.error("Error in chat room creation or message loading:", err);
      }
    },

    setupWebSocket() {
      if (this.chatSocket) {
        this.chatSocket.close();
      }

      this.chatSocket = new WebSocket(
        `wss://${process.env.VUE_APP_WEBSOCKET_BASE_URL}/ws/chat/${this.socketForRoomId}/?token=${this.token}`
      );
      const messageInput = document.querySelector('#chat-message-input');
      const messageSubmit = document.querySelector('#chat-message-submit');

      if (messageInput) {
        messageInput.focus();
        messageInput.onkeyup = (e) => {
          if (e.keyCode === 13) { 
            messageSubmit.click();
          }else{
            commonSocketConnectMethod.emit({
                type: "TypingEventForChat",
                message: 'typing',
                ChatRoomId: this.roomChatId
            });
            clearTimeout(this.typingTimeout); // Clear previous timeout using component property
            this.typingTimeout = setTimeout(() => { // Assign to component property
                commonSocketConnectMethod.emit({
                    type: "TypingEventForChat",
                    message: 'stop',
                    ChatRoomId: this.roomChatId
                });
            }, 2000);
          }
        };
      }

      if (messageSubmit) {
        messageSubmit.onclick = () => {
          const message = messageInput.value.trim();
          if (message.length > 0) {
            const payload = {
              chatRoomId: this.roomChatId,
              message: message,
              senderName: this.selfUserInfo.first_name + ' ' + this.selfUserInfo.last_name
            };
            if (this.messageIdForReply) {
              this.chatSocket.send(JSON.stringify({
                type: 'chat_message',
                message: {
                  content: message,
                  reply_to: this.messageIdForReply,
                }
              }));
            } else {
              this.chatSocket.send(JSON.stringify({
                type: 'chat_message',
                message: {
                  content: message,
                }
              }));
            }
            messageInput.value = '';
            commonSocketConnectMethod.emit({
                type: "TypingEventForChat",
                message: 'stop',
                ChatRoomId: this.roomChatId
            });
            bus.$emit('newChatMessage', payload);
            this.cancelReplyMessageOnChatMethod();
          }
        };
      }

      this.chatSocket.onopen = () => {
        // console.log('Chat WebSocket opened for room:', chatRoomSocketId);
        pingInterval = setInterval(() => {
          if (this.chatSocket.readyState === WebSocket.OPEN) {
            this.chatSocket.send(JSON.stringify({ type: 'ping' })); // Send a ping message
          }
        }, 30000); 
      };
      this.chatSocket.onmessage = (e) => {
        this.renderLiveMessageMethod(e);
        this.$nextTick(() => {
          this.scrollToBottom();
        });
      };

      this.chatSocket.onclose = (e) => {
        clearInterval(pingInterval);
        this.chatSocket = null;
      };

      this.chatSocket.onerror = (err) => {
        clearInterval(pingInterval);
        this.chatSocket = null;
      };
    },

   async messagesListAgainMethod(){
        const messagesResponse = await this.$store.dispatch('getUserSupportHelpChatDetailsByIdFun', { id: this.roomChatId });
        this.messagesList = messagesResponse.data.data.results;
        this.msgNextPageLoader = messagesResponse.data.data.next;
        const appendMessages = document.querySelector('#append_message');
        appendMessages.innerHTML = "";
        this.lastLiveMsgData = null;
    },
    renderLiveMessageMethod(e) {
      const data = JSON.parse(e.data);
      if(data.type == 'pong') {
       return;
      }else if(data.type == 'readStatus') {
       if(this.lastLiveMsgData){
        this.messagesListAgainMethod();
       }
       return;
      }else{  
       let messagesList = document.getElementById('append_message');
        this.displayChatMessageMethod(data.message, messagesList);
      } // Ensure we only process chat messages
    },

    displayChatMessageMethod(data, messagesList) {
      const selfUserId = this.selfUserId; // Assuming 'this' context is correct
      const isSelf = data.sender.user_id === selfUserId;
      if(data.delete_for_everyone){
          if (!isSelf) {
          bus.$emit('MessageDeleteForChatOfAllNotification', data);
          }
        return;
      }; // Assuming 'this' context is correct
      const message = data.message;
      // const messageElement = document.createElement('div');
      // messageElement.classList.add('live_msg');

      const messageContentWrapper = document.createElement('li');
      messageContentWrapper.id = `chatMessageId${data.id}`;
      messageContentWrapper.classList.add(isSelf ? 'sent' : 'received');
      // messageElement.appendChild(messageContentWrapper);

      const chatMessageBox = document.createElement('div');
      chatMessageBox.classList.add('chat_in_msg_box_wrp');
      messageContentWrapper.appendChild(chatMessageBox);


      // Add Forwarded Label if applicable
      if (data.forwarded) {
          chatMessageBox.appendChild(this.createForwardedLabelMethod());
      }

      // Add Reply Feature if applicable
      if (data.reply_to_msg) {
        chatMessageBox.appendChild(this.createReplyInfoMethod(data)); // Assuming 'message' is accessible here
      }

      // Add Message Content (File, Link, or Text)
      chatMessageBox.appendChild(this.createMessageContentMethod(data));

      // Add Dropdown for Options
      chatMessageBox.appendChild(this.createMessageOptionsDropdownMethod(data, this)); // Passing 'this' for context

      // Add Timestamp and Read Status
      const timeWrapper = document.createElement('span');
      timeWrapper.classList.add('msg_time_wrp');
      const timeElement = document.createElement('time');
      timeElement.classList.add('msg_time');
      if(data.sender.user_id === selfUserId){
        timeElement.textContent = moment(data.timestamp).format('h:mm a');
      }else{
        timeElement.textContent = "Lymphomap Admin, " +  moment(data.timestamp).format('h:mm a');
      }
      timeWrapper.appendChild(timeElement);
      messageContentWrapper.appendChild(timeElement);

      if (data.sender.user_id === selfUserId) {
        chatMessageBox.appendChild(this.createReadStatusLabelMethod(data));
      }

      messagesList.appendChild(messageContentWrapper);
      this.scrollToBottom();
    },

    createForwardedLabelMethod() {
        const forwardedMsgText = document.createElement("span");
        forwardedMsgText.classList.add('forwarded_msg_text');
        const shareIcon = document.createElement("i");
        shareIcon.classList.add('fa', 'fa-share');
        const forwardedMsgContent = document.createElement("span");
        forwardedMsgContent.textContent = 'Forwarded';
        forwardedMsgText.appendChild(shareIcon);
        shareIcon.after(forwardedMsgContent);
        return forwardedMsgText;
    },

    createReplyInfoMethod(replyData) {
      const showMsgOfReplyWrp = document.createElement("span");
      showMsgOfReplyWrp.classList.add('show_msg_of_reply_wrp');
      showMsgOfReplyWrp.style.borderLeftColor = replyData.sender.colour;

      const showMsgOfReplyName = document.createElement("span");
      showMsgOfReplyName.classList.add('show_msg_of_reply_name');
      showMsgOfReplyName.style.color = replyData.sender.colour;
      showMsgOfReplyName.textContent = `${replyData.sender.first_name} ${replyData.sender.last_name}`;

      let showMsgOfReplyTxt = document.createElement("span");
      showMsgOfReplyTxt.classList.add('show_msg_of_reply_txt');
      if(replyData.reply_to_msg.forwarded){
        if(replyData.reply_to_msg.forwarded_from.file){
          const link = document.createElement('a');
          link.href = replyData.reply_to_msg.forwarded_from.file;
          link.target = '_new';
          link.textContent = this.getFileName(replyData.reply_to_msg.forwarded_from.file);
          showMsgOfReplyTxt.appendChild(link);
        }else{
          showMsgOfReplyTxt.textContent = replyData.reply_to_msg.forwarded_from.message;
        }
      }else{
        if(replyData.reply_to_msg.file){
          const link = document.createElement('a');
          link.href = replyData.reply_to_msg.file;
          link.target = '_new';
          link.textContent = this.getFileName(replyData.reply_to_msg.file);
          showMsgOfReplyTxt.appendChild(link);
        }else{
          showMsgOfReplyTxt.textContent = replyData.reply_to_msg.message;
        }
      }
      showMsgOfReplyWrp.appendChild(showMsgOfReplyName);
      showMsgOfReplyName.after(showMsgOfReplyTxt);
      return showMsgOfReplyWrp;
    },
    createMessageContentMethod(data) {
        const contentWrapper = document.createElement('span');
        // Helper function to create and append a link element
        const createLinkElement = (href, textContent) => {
          const link = document.createElement('a');
          link.href = href;
          link.target = '_new';
          link.classList.add('hyper_link');
          link.textContent = textContent;
          return link;
        };

        // Helper function to create and append a text span
        const createTextSpan = (message) => {
          const textSpan = document.createElement('span');
          textSpan.innerHTML = message;
          return textSpan;
        };

        // Helper function to handle file rendering
        const renderFile = (fileUrl, messageContent) => {
          const msgExt = fileUrl.substring(fileUrl.lastIndexOf('.') + 1).split('?')[0];
          const link = createLinkElement(fileUrl, ''); // Link text will be the image/file
          const fileIcon = document.createElement('img');
          fileIcon.classList.add('img-fluid');

          if (['png', 'PNG', 'jpeg', 'jpg', 'svg', 'gif', 'webp'].includes(msgExt)) {
            fileIcon.src = fileUrl;
            const imgContainer = document.createElement('span');
            imgContainer.classList.add('msg_img_render_in_chat');
            imgContainer.appendChild(link);
            link.appendChild(fileIcon);
            contentWrapper.appendChild(imgContainer);
          } else {
            fileIcon.src = this.checkFileExtension(fileUrl);
            const fileRenderContainer = document.createElement('span');
            fileRenderContainer.classList.add('msg_file_render_in_chat');
            fileRenderContainer.appendChild(link);
            link.appendChild(fileIcon);

            const fileNameSpan = document.createElement('span');
            fileNameSpan.classList.add('msg_file_name');
            fileNameSpan.textContent = fileUrl.split('/').pop().split('?')[0]; // Use pop() for last segment
            link.appendChild(fileNameSpan); // Append fileNameSpan to the link
            contentWrapper.appendChild(fileRenderContainer);
          }

          // Append message content after the file/image, if it exists
          if (messageContent) {
            if (messageContent.startsWith('http://') || messageContent.startsWith('https://')) {
              contentWrapper.appendChild(createLinkElement(messageContent, messageContent));
            } else {
              contentWrapper.appendChild(createTextSpan(messageContent));
            }
          }
        };

        if (data.forwarded) {
          if (data.forwarded_from.file) {
            renderFile(data.forwarded_from.file, data.forwarded_from.message);
          } else if (data.forwarded_from.message) { // Only message, no file
            if (data.forwarded_from.message.startsWith('http://') || data.forwarded_from.message.startsWith('https://')) {
              contentWrapper.appendChild(createLinkElement(data.forwarded_from.message, data.forwarded_from.message));
            } else {
              contentWrapper.appendChild(createTextSpan(data.forwarded_from.message));
            }
          }
        } else if (data.file) {
          renderFile(data.file, data.message);
        } else if (data.message) { // Only message, no file and not forwarded
          if (data.message.startsWith('http://') || data.message.startsWith('https://')) {
            contentWrapper.appendChild(createLinkElement(data.message, data.message));
          } else {
            contentWrapper.appendChild(createTextSpan(data.message));
          }
        }

        return contentWrapper;
    },
    createMessageOptionsDropdownMethod(data, self) {
      const dropdownDiv = document.createElement("div");
      dropdownDiv.classList.add('dropdown');

      const msgToggleOption = document.createElement("span");
      msgToggleOption.classList.add('msg_toggle_option');
      msgToggleOption.setAttribute("data-toggle", 'dropdown');

      const faChevronDown = document.createElement("i");
      faChevronDown.classList.add('fa', 'fa-chevron-down');
      msgToggleOption.appendChild(faChevronDown);
      dropdownDiv.appendChild(msgToggleOption);

      const dropdownMenu = document.createElement("ul");
      dropdownMenu.classList.add('dropdown-menu');
      msgToggleOption.after(dropdownMenu);

      const replyLi = document.createElement("li");
      replyLi.textContent = 'Reply';
      replyLi.onclick = function () {
        self.replyMessageOnChatMethod(data);
      };
      dropdownMenu.appendChild(replyLi);
      if(data.sender.user_id === this.selfUserId){
        const deleteLi = document.createElement("li");
        deleteLi.textContent = 'Delete Message';
        deleteLi.onclick = function () {
          self.deteteMessageFromChatMethod(data.id, data.message, data.timestamp, data.sender.user_id);
        };
        dropdownMenu.appendChild(deleteLi);
      }

      return dropdownDiv;
    },

    createReadStatusLabelMethod(data) {
      this.lastLiveMsgData = data;
      const labelReadS = document.createElement("label");
      labelReadS.classList.add('message_indication_label');
      const labelReadI = document.createElement("i");
      labelReadI.classList.add('msg_indicated_dot');
      const liveMsgs = document.querySelectorAll('#messages .msg_indicated_dot');
      const apiMsgs = document.querySelectorAll('#append_message .msg_indicated_dot');
      if (this.messagesIndicationStatusMethod(data.message_statuses) == 'read') {
        labelReadI.setAttribute("class", 'msg_indicated_dot read');
        // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
        apiMsgs.forEach(element => {
          element.classList.remove('sent');
          element.classList.add('read'); // Replace 'your-new-class' with the class you want to add
        })
      } else if (this.messagesIndicationStatusMethod(data.message_statuses) == 'delivered') {
        labelReadI.setAttribute("class", 'msg_indicated_dot sent');
         // Iterate over each element and add a new class
        liveMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
              element.classList.remove('unsent');
              element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
         apiMsgs.forEach(element => {
          if (!element.classList.contains('read')) {
              element.classList.remove('unsent');
              element.classList.add('sent');
          } // Replace 'your-new-class' with the class you want to add
        })
      } else {
        labelReadI.setAttribute("class", 'msg_indicated_dot unsent');
      }
        labelReadS.appendChild(labelReadI);
        return labelReadS;
    },

    handleSupportChatClosedMethod(){
      this.openSupportChatState = false;
      const appendMessages = document.querySelector('#append_message');
      if(appendMessages){
        appendMessages.innerHTML = ""
      }
      this.cancelReplyMessageOnChatMethod();
      if (this.chatSocket) {
       this.chatSocket.close();
      }
    },
    
    urlify(text) {
      var urlRegex = /(((https?:\/\/)|(www\.))[^\s]+)/g;
      return text.replace(urlRegex, function (url, b, c) {
        var url2 = (c == 'www.') ? 'http://' + url : url;
        return '<a href="' + url2 + '" target="_blank" class="hyper_link">' + url + '</a>';
      })
    },

    /*
     * This Will File Sent In Chat Method Here
     */
    onInputClick(event) {
      event.target.value = ''
    },

    handleFileUpload(event) {
      this.imgSrc = ''
      if (event.target.files && event.target.files.length > 0) {
        this.uploadFile = event.target.files[0];
        this.filename = this.uploadFile.name;
        if (event.target.files[0].type.split('/')[0] == 'image') {
          if (typeof FileReader === 'function') {
            const reader = new FileReader();
            reader.onload = (event) => {
              this.imgSrc = event.target.result;
            };
            reader.readAsDataURL(this.uploadFile);
          } else {
            alert('Sorry, FileReader API not supported');
          }
        }
      }
    },
    /*
     * This Methods Code End For Chat Room Specific
     */
    getURLObj() {
      return window.URL || window.webkitURL;
    },
    captureImgOnPasteMethod(e) {
      if (e.clipboardData && e.clipboardData.items) {
        var items = e.clipboardData.items;
        for (var i = 0; i < items.length; i++) {
          if (items[i].type.indexOf('image') !== -1) {
            var blob = items[i].getAsFile();
            var URLObj = this.getURLObj();
            var source = URLObj.createObjectURL(blob);
            this.uploadFile = blob;
            this.imgSrc = source;
            this.filename = 'Photo';
            e.preventDefault();
          }
        }
      }
    },

    /*
     * This Will Check File Submitted In MSG Method Here
     */
    fileMsgSubmitMethod() {
      this.submitted = true
      let formData = new FormData();

      formData.append('chat_room_user', this.roomChatId);
      formData.append('message', this.fileMessage);
      formData.append('file', this.uploadFile);
      formData.append('filename', this.filename);
      
      this.fileUploadLoader = true;

      axios.post(UploadMsgFileURL, formData, {
        onUploadProgress: progressEvent => {
          this.uploadProgress = Math.round(
            (progressEvent.loaded / progressEvent.total) * 100
          );
        },
      }).then((res) => {
        const messageId = res.data.data.id;
        this.chatSocket.send(JSON.stringify({
          type: 'file_upload',
          message_id:messageId
        }));
        const payload = {
          chatRoomId: this.roomChatId
        };
        bus.$emit('newChatMessage', payload);
        this.cancelUploadFile();
      }).catch((err) => {
        toast.error(err.data.msg);
        this.fileUploadLoader = false;
        this.uploadProgress = 0;
        this.submitted = false;
      })
    },
    cancelUploadFile() {
      this.uploadFile = null;
      this.filename = '';
      this.fileMessage = '';
      this.fileUploadLoader = false;
      this.uploadProgress = 0;
      this.submitted = false;
    },
    
    fileOpenNewTab(href) {
      window.open(href, '_blank');
    },
    isImageFile(filePath) {
      const imageExtensions = ['png', 'jpeg', 'jpg', 'svg', 'gif', 'webp'];
      const fileExtension = filePath.split('.').pop().toLowerCase();
      let extension = fileExtension.substring(0, fileExtension.lastIndexOf("?"));
      return imageExtensions.includes(extension);
    },
    getFileName(filePath) {
      return filePath.split('/').pop().split('?')[0];
    },
    
    /*
     * This Will Delete Selected Message From Chat
    */
    deteteMessageFromChatMethod(messageId, MsgText, messageTime, createdBy) {
      this.deleteMessageDataObj.id = messageId;
      this.deleteMessageDataObj.time = messageTime;
      this.deleteMessageDataObj.text = MsgText;
      this.deleteMessageDataObj.createdBy = createdBy;
      this.deleteMessageDataObj.roomId = this.roomChatId;
      this.deleteMsgPopupState = true;
    },

    /*
     * This Will Reply Selected Message From Chat
    */
    replyMessageOnChatMethod(msgData) {
      this.replyMessageData = msgData;
      this.messageIdForReply = msgData.id;
      document.getElementById("chat-message-input").focus();
    },

    cancelReplyMessageOnChatMethod() {
      this.replyMessageData = null;
      this.messageIdForReply = "";
      this.textMessage = "";
      const messageSubmit = document.querySelector('#chat-message-input');
      if(messageSubmit){
        messageSubmit.innerHTML = ""
      }
    },

    scrollToBottom() {
      const elmnt = document.getElementById("chatbot_scroll");
      if (elmnt) {
        const y = elmnt.scrollHeight;
        $('#chatbot_scroll').animate({ scrollTop: y }, 20);
      }
    },
  },
  beforeDestroy() {
    if (this.chatSocket) {
      this.chatSocket.close();
    }
    document.getElementById("chatbot_scroll").removeEventListener("scroll", this.handleMessageLoader);
  },
};